export const APP_JWT_TOKEN = 'app.token';
export const APP_CLIENT_ID_QUERY_PARAM = 'client_id';
export const APP_REDIRECT_URI_QUERY_PARAM = 'redirect_uri';
export const APP_STATE_QUERY_PARAM = 'state';
